<template>
  <PageLayout class="home-page">
    <PageTitle>Панель управління</PageTitle>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <OnboardingCard v-if="isNeedOnboarding" :onboarding-data="onboardingInfo"/>
    <LastNews />
    <StatisticsSlider />
    <div class="home-page__dashboard">
      <div class="home-page__orders-summary">
        <OrdersHistory
          ref="ordersHistory"
          class="orders-history"
        />
        <Renewals class="renewals" />
      </div>
      <div class="home-page__tasks">
        <Tasks
          class="tasks"
          :grid-fixed-height="isDesktop"
          :calendar-gaps="calendarGaps"
        />
      </div>
    </div>
  </PageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { pages } from '@/entities/current-page';
import { LastNews } from '@/features/last-news';
import { OnboardingCard } from '@/features/onboarding-block';
import { StatisticsSlider } from '@/features/order-statistics';
import { OrdersHistory } from '@/features/orders-history';
import { Renewals } from '@/features/renewals';
import { Tasks } from '@/features/tasks';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';

const CALENDAR_HEIGHT = 366;
const ORDERS_HISTORY_PADDINGS = 64;

export default {
  data() {
    return {
      calendarGaps: 0,
      prolongationGaps: 0,
      tasksGaps: 0,

      breadcrumbs: [
        {
          title: 'Обліковий запис',
          path: '#',
        },
        {
          title: 'Панель управління',
          path: '#',
        }
      ],
    };
  },
  created() {
    this.changeActivePage(pages.HOME);
  },
  components: { PageLayout, PageTitle, Breadcrumbs, StatisticsSlider, OrdersHistory, Renewals, Tasks, LastNews, OnboardingCard },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop', 'windowWidth', 'windowHeight']),
    ...mapGetters('ordersHistoryModule', ['isOrdersDataReady']),
    ...mapGetters('currentUserModule', ['isMainPartner', 'isNeedOnboarding', 'isUnderReview', 'onboardingInfo']),
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
    calculateCalendarGaps() {
      this.$nextTick(() => {
        if (this.isDesktop) {
          const block = this.$refs.ordersHistory;
          const element = block?.$el || block;
          const rect = element?.getBoundingClientRect();
          const height = rect?.height || 0;
          this.calendarGaps = height ? (height - ORDERS_HISTORY_PADDINGS - CALENDAR_HEIGHT) / 2 : 0;
        } else {
          this.calendarGaps = 0;
        }
      });
    },
  },
  watch: {
    isOrdersDataReady: {
      handler: 'calculateCalendarGaps',
      immediate: false,
    },
    windowHeight: {
      handler: 'calculateCalendarGaps',
      immediate: true,
    },
    windowWidth: {
      handler: 'calculateCalendarGaps',
      immediate: true,
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep p {
  font-family: inherit;
  font-size: 14px;
  margin: 0;
  padding: 0;
}

.home-page {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  &__dashboard {
    display: flex;
    margin-bottom: 24px;

    @media (max-width: 1050px) {
      flex-direction: column;
    }
  }

  &__orders-summary {
    display: flex;
    flex-direction: column;
    width: 50%;

    @media (max-width: 1050px) {
      width: 100%;
      margin-bottom: 24px;
    }
  }

  &__tasks {
    display: flex;
    flex-direction: column;
    width: 50%;

    @media (max-width: 1050px) {
      width: 100%;
    }
  }
}

.renewals, .tasks {
  height: 100%;
}
</style>
